/**
 * 操作ログ詳細パネル
 */

import {
  Stack,
  Grid,
  Text,
  Paper,
  ScrollArea,
  Code,
  Center,
  Loader,
} from "@mantine/core";
import { OperationLog } from "../../services/operationLogService";

interface OperationLogDetailPanelProps {
  log: OperationLog;
  detail: OperationLog | undefined;
  loading: boolean;
}

/**
 * 操作ログ詳細パネル
 */
export function OperationLogDetailPanel({
  detail,
  loading,
}: OperationLogDetailPanelProps) {
  if (loading) {
    return (
      <Center py="md">
        <Loader size="sm" type="dots" />
        <Text size="xs" ml="xs" c="dimmed">
          詳細を取得中...
        </Text>
      </Center>
    );
  }

  if (!detail) {
    return (
      <Text size="xs" c="dimmed">
        詳細を読み込めませんでした。
      </Text>
    );
  }

  return (
    <Stack
      gap="md"
      p="md"
      bg="var(--mantine-color-body)"
      style={{
        borderRadius: "8px",
        border: "1px solid var(--mantine-color-default-border)",
      }}
    >
      <Grid grow align="flex-start">
        <Grid.Col span={6}>
          <Stack gap={4}>
            <Text size="xs" c="dimmed" fw={700}>
              操作者詳細
            </Text>
            <Text size="sm">
              {detail.operator.role} (UID: {detail.operator.uid})
            </Text>
          </Stack>
        </Grid.Col>
        <Grid.Col span={6}>
          <Stack gap={4}>
            <Text size="xs" c="dimmed" fw={700}>
              対象の詳細
            </Text>
            <Text size="sm">
              {detail.resource.type}{" "}
              {detail.resource.id ? `(ID: ${detail.resource.id})` : ""}
            </Text>
            {detail.resource.name && (
              <Text size="sm">プレビュー名: {detail.resource.name}</Text>
            )}
          </Stack>
        </Grid.Col>
      </Grid>

      {detail.error && (
        <Stack gap={4}>
          <Text size="xs" c="dimmed" fw={700} color="red">
            エラーメッセージ
          </Text>
          <Paper p="xs" withBorder bg="red.0" color="red.9">
            <Text size="sm" ff="monospace">
              {detail.error}
            </Text>
          </Paper>
        </Stack>
      )}

      <Stack gap={4}>
        <Text size="sm" c="dimmed" fw={700}>
          詳細データ (JSON)
        </Text>
        <ScrollArea>
          <Code block style={{ fontSize: "12px" }}>
            {JSON.stringify(detail.details, null, 2)}
          </Code>
        </ScrollArea>
      </Stack>
    </Stack>
  );
}
